/**
 * AnimateFloatingCTA — 134×32 floating button inside imageContainer.
 *
 * Figma source: node `40000026:11843` uiButton accent/sm.
 * Gradient fill: #CB30E0 → #0088FF, per-stop alpha 48%.
 * Backdrop-blur: 32px. cornerRadius: 24. Padding 16/13/16/13, gap 6.
 * Icon: `generate` 13×12. Text: Raleway Bold 12, letter-spacing -2%.
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../../primitives';

export default function AnimateFloatingCTA({ onClick }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative inline-flex items-center justify-center gap-1.5 overflow-hidden rounded-home-24 font-sans font-bold text-text-primary"
      style={{
        height: 32,
        paddingLeft: 16,
        paddingRight: 16,
        background: 'linear-gradient(90deg, rgba(203,48,224,0.48) 0%, rgba(0,136,255,0.48) 100%)',
        backdropFilter: 'blur(32px)',
        WebkitBackdropFilter: 'blur(32px)',
        flexShrink: 0,
      }}
      aria-label={t('viewer.animatePhoto')}
      data-testid="animate-photo-cta"
    >
      <span className="viewer-cta-shine" aria-hidden="true" data-testid="animate-photo-shine" />
      <Icon name="generate" size={13} className="relative z-10 text-text-primary" />
      <span className="relative z-10" style={{ fontSize: 12, lineHeight: '14px', letterSpacing: 0 }}>
        {t('viewer.animatePhoto')}
      </span>
    </button>
  );
}
